<nav id="navigation" class="style-1">
    <ul id="responsive">
        <li>
            <a [routerLink]="''" routerLinkActive="current" [routerLinkActiveOptions]="{exact: true}">Home</a>
        </li>
        <li>
            <a [routerLink]="'/properties'" routerLinkActive="current">Properties</a>
        </li>
        <li>
            <a [routerLink]="'/contact-us'" routerLinkActive="current">Contact Us</a>
        </li>
        <li>
            <a [routerLink]="'/about-us'" routerLinkActive="current">About Us</a>
        </li>
    </ul>
</nav>
